import { useLazyQuery } from '@apollo/client'
import { GetPatientNotApprovedInsuranceCompanies } from '../../types'
import { GET_PATIENTS_NOT_APPROVED_INSURANCE_COMPANIES } from './operations'

type Props = {
  onCompleted?: (data: GetPatientNotApprovedInsuranceCompanies) => void
}

export const useGetPatientsNotApprovedInsuranceCompanies = ({ onCompleted }: Props) =>
  useLazyQuery<GetPatientNotApprovedInsuranceCompanies>(
    GET_PATIENTS_NOT_APPROVED_INSURANCE_COMPANIES,
    {
      onCompleted,
    }
  )
